import axios from "axios";
import { responseInterceptor } from "http-proxy-middleware";
import { setSnackBar } from "../stores/ui/ui-action";
import URL from "../utils/urls";
import { CodatCompanyRes } from "../stores/company/company-state";

export const LINKED_STATUS = 'Linked';

export async function getAllIntegrations() {
    const { data } = await axios.get(
        URL.accounting.getAllIntegrations
    );
    return data.results ? data.results : [];
}

export async function createCodatCompany(company: string, adfId?: string, journeyId?: string) {
    const { data } = await axios.post(URL.accounting.createCompany, { name: company, i2cId: adfId, journeyId }, { headers: { "content-type": "application/json" } });
    return data;
}

export async function getCompany(companyId: string) {
    const { data } = await axios.get(URL.accounting.getCompany(companyId));
    return data;
}

export async function getCompanyId(adfId?: string, dlaXavierCompanyId?: string) {
    try {
        if (adfId) {
            return getADFCodatCompanyId(adfId)
        } else {
            return getDLACodatCompanyId(dlaXavierCompanyId)
        }
    } catch (e) {
    }
}

async function getADFCodatCompanyId(adfId: string): Promise<string> {
    const response = await axios.get(URL.accounting.getI2CCompanyId(adfId));
    // No result
    if (response?.data?.length === 0) {
        return ''
    }
    // Old response type of only the id string
    if (typeof response?.data?.[0] === 'string') {
        return response.data[0]
    }
    // New response type for filtering
    return response.data.find(item => item.source_id === adfId).codat_company_id
}

async function getDLACodatCompanyId(xavierCompanyId: string): Promise<string> {
    const response = await axios.get(URL.accounting.getCompanyId);
    // No result
    if (response?.data?.length === 0) {
        return ''
    }
    // Old response type of only the id string
    if (typeof response?.data?.[0] === 'string') {
        return response.data[0]
    }
    // New response type for filtering
    return response.data.find(item => item.lendx_company_id === xavierCompanyId)?.codat_company_id
}

export async function createConnection(companyId, platformKey, dispatch) {

    try {
        const response = await axios.post(
            URL.accounting.createConnection(companyId),
            platformKey,
            { headers: { "content-type": "application/json" } }
        )

        if (response && response.data) {
            return response.data;
        } else {
            return null;
        }

    } catch (error) {
        if (error.response.status === 409) {
            dispatch(setSnackBar({ show: true, message: 'Problem creating new connection. Connection already exists.', messageType: "error" }));
        } else {
            dispatch(setSnackBar({ show: true, message: 'Problem creating connection with Accounting Software.', messageType: "error" }));
        }
    }
}

export async function getCodatCompanies():Promise<CodatCompanyRes> {
    const response = await axios.get(URL.codat.getCodatCompanies)
    return response.data;
}

export async function deleteConnection(company: string, connectionId: string) {
    const response = await axios.delete(URL.accounting.deleteConnection(company, connectionId));
    return response;
}